<template>
  <div id="qrcode">
    <div class="space"></div>
    <b-container class="bv-example-row">
      <b-row>
        <b-col cols="2"> </b-col>
        <b-col cols="8">
          <div
            class="card card-order-list card-margin shadow border-light"
            style="border-radius: 40px"
          >
            <div class="card-body">
              <h4>กิจกรรม {{ $route.params.id }}</h4>
            </div>
          </div>
        </b-col>
        <b-col cols="2"> </b-col>
      </b-row>

      <br />
      <b-row>
        <b-col cols="4"> </b-col>
        <b-col col="4">
          <div class="card-columns">
            <div class="card card-order-list card-margin shadow border-light">
              <div class="card-body card-qrcode">
                <qr-code :text="genqrcode"> </qr-code>
              </div>
            </div>
          </div>
        </b-col>
        <b-col col="4"> </b-col>
      </b-row>
    </b-container>

    <b-container class="bv-example-row">
      <div class="card-columns">
        <div
          class="card card-order-list card-margin border-0 border-light shadow"
          style="border-radius: 40px; padding: 30px"
        >
          <div class="card-body">
            <div class="card-columns-rate-star">
              <div
                class="card card-order-list card-margin shadow-sm border-light"
                style="border-radius: 40px"
              >
                <div class="card-body">
                  <b-row>
                    <b-col cols="4">
                      <b-avatar variant="info" pull-right size="md"></b-avatar>
                    </b-col>
                    <b-col cols="8">
                      <div class="star-ratings" style="margin-left: -25px">
                        <div class="fill-ratings" style="width: 60%">
                          <span>★★★★★</span>
                        </div>
                        <div class="empty-ratings">
                          <span>★★★★★</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <!--  -->
              <div
                class="card card-order-list card-margin shadow border-light"
                style="border-radius: 40px"
              >
                <div class="card-body">
                  <b-row>
                    <b-col cols="4">
                      <b-avatar
                        variant="success"
                        pull-right
                        size="md"
                      ></b-avatar>
                    </b-col>
                    <b-col cols="8">
                      <div class="star-ratings" style="margin-left: -25px">
                        <div class="fill-ratings" style="width: 40%">
                          <span>★★★★★</span>
                        </div>
                        <div class="empty-ratings">
                          <span>★★★★★</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <!--  -->
              <div
                class="card card-order-list card-margin shadow border-light"
                style="border-radius: 40px"
              >
                <div class="card-body">
                  <b-row>
                    <b-col cols="4">
                      <b-avatar
                        variant="primary"
                        pull-right
                        size="md"
                      ></b-avatar>
                    </b-col>
                    <b-col cols="8">
                      <div class="star-ratings" style="margin-left: -25px">
                        <div class="fill-ratings" style="width: 20%">
                          <span>★★★★★</span>
                        </div>
                        <div class="empty-ratings">
                          <span>★★★★★</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <!--  -->
              <div
                class="card card-order-list card-margin shadow border-light"
                style="border-radius: 40px"
              >
                <div class="card-body">
                  <b-row>
                    <b-col cols="4">
                      <b-avatar
                        variant="warning"
                        pull-right
                        size="md"
                      ></b-avatar>
                    </b-col>
                    <b-col cols="8">
                      <div class="star-ratings" style="margin-left: -25px">
                        <div class="fill-ratings" style="width: 100%">
                          <span>★★★★★</span>
                        </div>
                        <div class="empty-ratings">
                          <span>★★★★★</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <!-- end row1 -->
              <div
                class="card card-order-list card-margin shadow border-light"
                style="border-radius: 40px"
              >
                <div class="card-body">
                  <b-row>
                    <b-col cols="4">
                      <b-avatar
                        variant="primary"
                        pull-right
                        size="md"
                      ></b-avatar>
                    </b-col>
                    <b-col cols="8">
                      <div class="star-ratings" style="margin-left: -25px">
                        <div class="fill-ratings" style="width: 20%">
                          <span>★★★★★</span>
                        </div>
                        <div class="empty-ratings">
                          <span>★★★★★</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <!--  -->
              <div
                class="card card-order-list card-margin shadow border-light"
                style="border-radius: 40px"
              >
                <div class="card-body">
                  <b-row>
                    <b-col cols="4">
                      <b-avatar
                        variant="success"
                        pull-right
                        size="md"
                      ></b-avatar>
                    </b-col>
                    <b-col cols="8">
                      <div class="star-ratings" style="margin-left: -25px">
                        <div class="fill-ratings" style="width: 40%">
                          <span>★★★★★</span>
                        </div>
                        <div class="empty-ratings">
                          <span>★★★★★</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <!--  -->
              <div
                class="card card-order-list card-margin shadow border-light"
                style="border-radius: 40px"
              >
                <div class="card-body">
                  <b-row>
                    <b-col cols="4">
                      <b-avatar
                        variant="danger"
                        pull-right
                        size="md"
                      ></b-avatar>
                    </b-col>
                    <b-col cols="8">
                      <div class="star-ratings" style="margin-left: -25px">
                        <div class="fill-ratings" style="width: 40%">
                          <span>★★★★★</span>
                        </div>
                        <div class="empty-ratings">
                          <span>★★★★★</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <!--  -->
            </div>
            <!-- <div class="star-ratings">
              <div class="fill-ratings" style="width: 60%">
                <span>★★★★★</span>
              </div>
              <div class="empty-ratings">
                <span>★★★★★</span>
              </div>
            </div> -->
          </div>
        </div>
        <!--  -->
        <!-- <div class="card card-order-list card-margin shadow border-light">
          <div class="card-body">
            <div class="star-ratings">
              <div class="fill-ratings" style="width: 40%">
                <span>★★★★★</span>
              </div>
              <div class="empty-ratings">
                <span>★★★★★</span>
              </div>
            </div>
          </div>
        </div> -->
        <!--  -->
        <!-- <div class="card card-order-list card-margin shadow border-light">
          <div class="card-body">
            <div class="star-ratings">
              <div class="fill-ratings" style="width: 40%">
                <span>★★★★★</span>
              </div>
              <div class="empty-ratings">
                <span>★★★★★</span>
              </div>
            </div>
          </div>
        </div> -->
        <!--  -->
      </div>
    </b-container>
  </div>
</template>

<script>
import $ from "jquery";
// import VueQRCodeComponent from 'vue-qr-generator'
export default {
  components: { },
  name: "qrcode",
  data() {
    return {
      genqrcode: "",
    };
  },
  mounted() {
    this.genqrcode = "https://usl.ubru.ac.th/rate/" + this.$route.params.id;
    console.log(this.genqrcode);
    $(document).ready(function () {
      // Gets the span width of the filled-ratings span
      // this will be the same for each rating
      var star_rating_width = $(".fill-ratings span").width();
      // Sets the container of the ratings to span width
      // thus the percentages in mobile will never be wrong
      $(".star-ratings").width(star_rating_width);
    });
  },
  methods: {},
};
</script>

<style scoped>
.card-qrcode {
  padding: 45px;
}
.space {
  height: 60px;
}
/* .star {
  position: relative;
  font-size: 1.5em;
  font-family: FontAwesome;
}

.star:before {
  content: "";
  color: #f4c2be;
}

.full:before {
  color: var(--red-color);
}

.half:after {
  content: "";
  position: absolute;
  left: 0;
  color: var(--red-color);
}
.recipe-card > :is(.rating, .recipe-infos) {
  transform: translateY(-20px);
} */
/*  */
.star-ratings {
  unicode-bidi: bidi-override;
  color: #ccc;
  font-size: 30px;
  position: relative;
  margin: 0;
  padding: 0;
  font-family: FontAwesome;
}
.star-ratings .fill-ratings {
  color: #ffd700;
  /* #ff7a70; */
  padding: 0;
  position: absolute;
  z-index: 1;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;
  font-family: FontAwesome;
}
.star-ratings .fill-ratings span {
  display: inline-block;
  font-family: FontAwesome;
}
.star-ratings .empty-ratings {
  padding: 0;
  display: block;
  z-index: 0;
}
/*  */

/* card */
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-rate-star {
    column-count: 4;
  }
  .card-rate {
    column-count: 6;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-rate-star {
    column-count: 4;
  }
  .card-rate {
    column-count: 6;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-rate-star {
    column-count: 4;
  }
  .card-rate {
    column-count: 6;
  }
}
</style>
